import { render } from "./LbrxMultiPayPopup.vue?vue&type=template&id=be0298ba&scoped=true"
import script from "./LbrxMultiPayPopup.vue?vue&type=script&lang=js"
export * from "./LbrxMultiPayPopup.vue?vue&type=script&lang=js"

import "./LbrxMultiPayPopup.vue?vue&type=style&index=0&id=be0298ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be0298ba"]])

export default __exports__